import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import { keyframes } from '@mui/material/styles';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Navbar from './Navbar';
import Footer from './Footer';
import PharmacyBackground from './PharmacyBackground';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

export default function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isDownloadPage = location.pathname === '/download';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative' }}>
      <PharmacyBackground />
      <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <Box component="main" sx={{ flexGrow: 1, pb: { xs: 9, md: 0 } }}>
          <Outlet />
        </Box>
        <Box sx={{ mb: { xs: 8, md: 0 } }}>
          <Footer />
        </Box>

        {!isDownloadPage && (
          <Fab
            color="primary"
            onClick={() => navigate('/download')}
            aria-label="Download App"
            sx={{
              position: 'fixed',
              bottom: { xs: 80, md: 28 },
              right: 20,
              zIndex: (theme) => theme.zIndex.appBar - 1,
              width: { xs: 52, md: 58 },
              height: { xs: 52, md: 58 },
              background: 'linear-gradient(135deg, #D4A574, #B8894A)',
              boxShadow: '0 6px 24px rgba(184,137,74,0.4)',
              animation: { xs: 'none', md: `${bounce} 3s ease-in-out infinite` },
              willChange: 'auto',
              touchAction: 'manipulation',
              '&:hover': {
                background: 'linear-gradient(135deg, #B8894A, #8F6A35)',
                boxShadow: '0 8px 32px rgba(184,137,74,0.55)',
              },
            }}
          >
            <SmartphoneIcon sx={{ fontSize: { xs: 26, md: 28 } }} />
          </Fab>
        )}
      </Box>
    </Box>
  );
}
